import { render } from "./TransactionsIndex.vue?vue&type=template&id=16a0143f"
import script from "./TransactionsIndex.vue?vue&type=script&lang=js"
export * from "./TransactionsIndex.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__